import { createStore } from 'vuex';

import * as storage from 'store';
import zh_CN from 'ant-design-vue/es/locale/zh_CN';
import en_US from 'ant-design-vue/es/locale/en_US';
import { randomUUID } from '@/utils/util';
import { getEncryptedString } from '@/utils/crypt';
import {
  ACCESS_KEY,
  ACCESS_TOKEN,
  USER_INFO,
  ENCRYPTED_STRING
} from './mutation-types';
import i18n from '../lang';
import { queryAllEnabledLanguage, queryAllInternation } from '../api/apis';

const store = createStore({
  state: {
    lang: storage.get('lang') || 'zh_CN',
    antdvLocale: zh_CN,
    langs: storage.get('langs') || [],
    langMessage: storage.get('langMessage')
      ? storage.get('langMessage')[storage.get('lang') || 'zh_CN']
        ? storage.get('langMessage')[storage.get('lang') || 'zh_CN']
        : {}
      : {},
    access_token: storage.get(ACCESS_TOKEN) || null,
    online: true,
    access_key: storage.get(ACCESS_KEY) || null,
    encryptedString: storage.get(ENCRYPTED_STRING) || null,
    userInfo: storage.get(USER_INFO) || null,
    inquireFormData: storage.get('inquireFormData') || null,
    previousUrl: null
  },
  mutations: {
    setLang(state, lang) {
      if (lang) {
        i18n.global.locale = lang;
        state.lang = lang;
        storage.set('lang', lang);
        const title = i18n.global.t('common.brower_title');
        document.title = title;
      }
    },
    setLangs(state, langs) {
      if (langs) {
        state.langs = langs;
        storage.set('langs', langs);
      }
    },
    setLangMessage(state, message) {
      if (message) {
        // prod env set
        const localeMessages = i18n.global.getLocaleMessage(state.lang);
        i18n.global.setLocaleMessage(state.lang, {
          ...message,
          ...localeMessages
        });
        state.langMessage = message;
        const title = i18n.global.t('common.brower_title');
        document.title = title;
        storage.set('langMessage', message);
      }
    },
    network(state, network) {
      state.online = network;
    },
    SET_ANTD_LOCALE: (state, locale) => {
      state.antdvLocale = locale;
    },
    SET_ACCESS_KEY: (state, key) => {
      state.access_key = key;
      storage.set(ACCESS_KEY, key);
    },
    SET_ACCESS_TOKEN: (state, token) => {
      state.access_token = token;
      storage.set(ACCESS_TOKEN, token);
    },
    SET_ENCRYPTSTRING: (state, es) => {
      state.encryptedString = es;
      storage.set(ENCRYPTED_STRING, es);
    },
    SET_INFO: (state, info) => {
      state.userInfo = info;
      storage.set(USER_INFO, info);
    },
    clearLoginInfo: state => {
      state.access_token = null;
      state.userInfo = null;
      storage.remove(ACCESS_TOKEN);
      storage.remove(USER_INFO);
    },
    setInquireFormData(state, formData) {
      state.inquireFormData = formData;
      storage.set('inquireFormData', formData);
    },
    clearInquireFormData(state) {
      state.inquireFormData = null;
      storage.remove('inquireFormData');
    },
    setPreviousUrl(state, url) {
      state.previousUrl = url;
    }
  },
  actions: {
    setLang({ commit }, lang) {
      commit('setLang', lang);

      if (lang) {
        // set antd locale
        new Promise((resolve, reject) => {
          import(`ant-design-vue/es/locale/${lang}`)
            .then(module => {
              resolve(module.default);
            })
            .catch(err => {
              reject(err);
            });
        }).then(antdLocale => {
          commit('SET_ANTD_LOCALE', antdLocale);
        });
      }
    },
    async changeAndSetLangMessage({ commit }, locale) {
      const res = await queryAllInternation({ locale });
      if (res.success) {
        commit('setLangMessage', res.result[locale]);
      }
    },
    async reloadMsg({ commit, state }) {
      const res = await queryAllInternation({ locale: state.lang });
      if (res.success) {
        commit('setLangMessage', res.result[state.lang]);
      }
    },
    async loadLocales({ commit }) {
      const res = await queryAllEnabledLanguage();
      if (res.success) {
        commit('setLangs', res.result);
      }
    },
    setTokenAndUserInfo({ commit }, { token, userInfo }) {
      commit('SET_ACCESS_TOKEN', token);
      commit('SET_INFO', userInfo);
    },
    getEncryptedString({ commit }) {
      const key = randomUUID();
      commit('SET_ACCESS_KEY', key);
      storage.set(ACCESS_KEY, key);
      getEncryptedString().then(str => {
        commit('SET_ENCRYPTSTRING', str);
      });
    },
    clearLoginInfo({ commit }) {
      commit('clearLoginInfo');
    },
    setInquireFormData({ commit }, formData) {
      commit('setInquireFormData', formData);
    },
    clearInquireFormData({ commit }) {
      commit('clearInquireFormData');
    }
  },
  modules: {}
});

export const initData = async () => {
  await store.dispatch('loadLocales');
  await store.dispatch('changeAndSetLangMessage', store.state.lang);
  const lang = storage.get('lang');
  if (lang) {
    new Promise((resolve, reject) => {
      import(`ant-design-vue/es/locale/${lang}`)
        .then(module => {
          resolve(module.default);
        })
        .catch(err => {
          reject(err);
        });
    }).then(antdLocale => {
      store.commit('SET_ANTD_LOCALE', antdLocale);
    });
  }
};

// initData();

export default store;
